export const environment = {
	production: true,
	url :'https://backend-translogic.iogreen.in',
	voucher_email_1 : 'meghneel.adke@iogreen.in',
  	voucher_email_2 : 'ninad.kulkarni@iogreen.in'
};



// WEBPACK FOOTER //
// /Users/meghneel/work/shree_translogic_dashboard/src/environments/environment.ts